import { render } from "./EventTeams.vue?vue&type=template&id=bc3d4190"
import script from "./EventTeams.vue?vue&type=script&lang=js"
export * from "./EventTeams.vue?vue&type=script&lang=js"

import "./EventTeams.vue?vue&type=style&index=0&id=bc3d4190&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__